import axios from '../axiosInstance';

import type {
  ProjectV2SetActiveResponse,
  ProjectsV2Response,
  ProjectsV2SearchResponse,
} from '../types/projectV2';

export const getProjectsV2 = async (
  includeEntireAccount: boolean,
  lastCursor?: string | null,
): Promise<ProjectsV2Response> => {
  const { data } = await axios.get<ProjectsV2Response>('/projects/v2', {
    params: { includeEntireAccount, lastCursor: lastCursor || undefined },
  });
  return data;
};

export const searchProjectsV2 = async (
  searchKey: string,
  selectedOwner?: string,
): Promise<ProjectsV2SearchResponse> => {
  const { data } = await axios.get<ProjectsV2SearchResponse>('/projects/search', {
    params: { searchKey, email: selectedOwner || undefined },
  });
  return data;
};

export const setActiveVersionV2 = async (
  parentProjectId: string,
  projectId: string,
): Promise<ProjectV2SetActiveResponse> => {
  const { data } = await axios.patch<ProjectV2SetActiveResponse>(
    `/projects/parent/${parentProjectId}/activate/${projectId}`,
  );
  return data;
};

export const getProjectOwnersV2 = async (): Promise<string[]> => {
  const { data } = await axios.get<string[]>('/projects/owners');
  return data;
};
